<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t('topupRecord') }}</h2>
		<el-divider></el-divider>
		<template v-if="store_management === '1'">
			<el-form ref="storeform" :model="storeform">
				<el-form-item :label="$t('selectStore')">
					<template>
						<div class="" style="display: flex">
							<el-select v-model="storeform.storeid" placeholder="" @change="changeTableStoreid">
								<el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
								<el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
									:value="item.storeid" :key="item.storeid"></el-option>
							</el-select>
						</div>
					</template>
				</el-form-item>
			</el-form>
		</template>
        <template v-if="store_management === '1'">
			<el-table :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" stripe
				@sort-change="sortChange" style="width: 100%">
				<el-table-column prop="storeid" :label="$t('storeid')" sortable="custom">
				</el-table-column>
                <el-table-column prop="orderid" :label="$t('orderid')" sortable="custom">
				</el-table-column>
                <el-table-column prop="name" :label="$t('topupPlan')" sortable="custom">
				</el-table-column>
                <el-table-column prop="month" :label="$t('subscriptionPeriod')" sortable="custom">
                    <template slot-scope="scope">
                    <div v-if="scope.row.plan_type === 'custom'">-</div>
                    <div v-if="scope.row.plan_type === 'monthly'">{{ scope.row.month }}{{ $t("months") }}</div>
                    </template>
				</el-table-column>
                <el-table-column prop="amount" :label="$t('totalAmount')" sortable="custom">
				</el-table-column>
                <el-table-column prop="paymentid" :label="$t('paymentid')" sortable="custom">
				</el-table-column>
                <el-table-column prop="paymentmethod" :label="$t('paymentMethod')" sortable="custom">
				</el-table-column>
                <el-table-column  :label="$t('paymentTime')" sortable="custom">
                    <template slot-scope="scope">
                        <div>{{ scope.row.paymenttime | formatDate }} </div>
                    </template>
				</el-table-column>


			</el-table>
			<div class="pagination flex-center">
				<span class="el-pagination__total">{{ $t("total") }} {{ tableData.length }} {{ $t("items") }}</span>
				<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-size="pageSize" layout="prev,pager,next" :total="tableData.length"></el-pagination>
			</div>
		</template>
		<template v-if="store_management === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>



        




        

	</div>
</template>
<script>
import {
	formatDate
} from '../../assets/date.js'
import axios from 'axios'
import {
	tongyong,
	funk,
	getStore,
	getStoreTopuplist,
    getStoreTopupusage
} from '@/api'
import {
	addAutoTemplate
} from '@/api'
export default {
	data() {
		return {
			store_management: '0',
			exportcsv: '0',
			qyid: '',
            storeid:'',
			dialogImageUrl: '',
			fileList: [],
			disabled: false,
			showViewer: false, // 显示查看器
			ewmdata: [],
			fileList: [],
			pagelist: [],
			huodonglist: [],
			currentPage: 1, // 当前页码
			pageSize: 20, // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			tab: [{
				label: this.$t('underApproval'),
				id: '0'
			},
			{
				label: this.$t('passed'),
				id: '1'
			}
			],
			tableData: [],
			metaTemplateList: [],
			status: 0,
			form: {
				qyid: '',
				storeid: '',
				name: '',
				businesswhatsapp: '',
				adminwhatsapp: '',
				adminemail: '',
                isshipping: false,
                shippingflowid: ''

			},
            storelist: [],
            storeform: {
				storeid: ''
			},
        }
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000 //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},
    mounted() {
        this.storeid = this.$route.params.topupstoreid;
        this.storeform.storeid = this.$route.params.topupstoreid;
    },
	created() {
		var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        this.qyid = auser.qyid
        //this.storeid = auser.storeid
        this.storeid = this.$route.params.topupstoreid;
        this.storeform.storeid = this.$route.params.topupstoreid;
        this.store_management = auser.store_management
        this.exportcsv = auser.exportcsv
		this.gettemplist()
        this.getstorelist()
	},
	methods: {
		addstore() {
			this.dialogVisible = true
			this.form = {}
		},
		edititem(data) {
			this.form = data
			this.dialogVisible = true
		},
		beforeHandleCommand(e) {
			console.log(e);
		},
		// 页面切换方法
		handleCurrentChange(val) {
			this.currentPage = val;
		},
        handleStoreauthorizeListCurrentChange(val) {
			this.storeauthorizeListCurrentPage = val;
		},
        handleStoreposListCurrentChange(val) {
			this.storeposListCurrentPage = val;
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.status = tab.index
			this.currentPage = 1
			this.gettemplist()
		},
		handleClose() {
			this.dialogVisible = false
		},
		handlePictureCardPreview() {

		},
		handleRemove() {

		},
		// 我的範本列表
		gettemplist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			/*
			let fdata = {
				sjk: 'messenger_storelist',
				action: 'list',
				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(fdata);
					console.log(res);
					this.tableData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})*/

			let fdata = {
				qyid: this.qyid,
                storeid: this.storeform.storeid,
                action: "viewtopuprecord"
			};
            console.log("fdataaaaaaaa");
            console.log(fdata);
			getStoreTopuplist(fdata).then((res) => {
				if (res.code == 1) {
                    console.log("AAAAAA");
					console.log(res);
					this.tableData = res.data;
                    
				} else {
                    console.log("B");
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
        changeTableStoreid() {
			this.gettemplist()
		},


		//pagelist 
		getpagelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_pagelist',
				action: 'list',

				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.pagelist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

        difference(item1, item2) {
            return item2 - item1
        },
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		},
        getstorelist() {
			let fdata = {
				//qyid: user.id,
				qyid: this.qyid,
                //storeid: this.storeid
			};
			getStore(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.storelist = res.data
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},




	}
}
</script>
<style lang="scss" scoped>
.equal-height-container {
  display: flex;
}

.el-row {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}

.el-col {
  display: flex;
  margin-bottom: 20px; /* Replace gutter for flexbox */
}

.content-box {
  flex: 1;
  background: #f5f7fa;
  padding: 20px;
  border-radius: 4px;
  width: 100%;
}

/* For extra small screens */
@media (max-width: 768px) {
  .el-col {
    flex: 0 0 calc(50% - 10px); /* xs=12 means 50% width */
    margin: 0 5px 20px 5px;
  }
}

/* For large screens */
@media (min-width: 1200px) {
  .el-col {
    flex: 0 0 calc(50% - 10px); /* lg=12 means 50% width */
    margin: 0 5px 20px 5px;
  }
}

/* For medium screens (span=6 means 25% width) */
@media (min-width: 769px) and (max-width: 1199px) {
  .el-col {
    flex: 0 0 calc(25% - 15px);
    margin: 0 7.5px 20px 7.5px;
  }
}

.centered-content {
  text-align: center; /* Center text content */
}

.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

::v-deep .el-select {
	width: 100%;

}

.label {
    font-size: 24px;
    font-weight: bold;
    color: rgba(0, 0, 0, .45);
    text-align: center;
}

@media screen and (max-width: 768px) {
    .label {
        font-size: 12px;
        text-align: center;
    }
}
</style>
